import { RolesEnum } from 'app/shared/enums/roles.enum';
import { AppMenu } from './app-menu.model';
import { TenantSettingType } from 'app/shared/models/tenant.model';

export const BackOfficeMenu: AppMenu = new AppMenu({
  items: [
    {
      id: 'store',
      title: 'Store',
      type: 'section',
      children: [
        {
          id: 'dashboard',
          title: 'MENU.DASHBOARD',
          type: 'item',
          icon: 'home',
          url: 'dashboard',
          onlyRoles: [RolesEnum.Customer, RolesEnum.CustomerOwner, RolesEnum.AgencyOwner, RolesEnum.Agent, RolesEnum.StoreOwner, RolesEnum.StoreUser, RolesEnum.Administrator]
        },
        {
          id: 'customer-detail',
          title: 'MENU.CUSTOMER_INFO',
          type: 'item',
          icon: 'info',
          url: 'customer-detail',
          onlyRoles: [RolesEnum.CustomerOwner]
        },
        {
          id: 'agency-info',
          title: 'MENU.AGENCY_INFO',
          type: 'item',
          icon: 'info',
          url: 'agency-info',
          onlyRoles: [RolesEnum.AgencyOwner]
        },
        {
          id: 'orders',
          title: 'MENU.ORDERS',
          type: 'item',
          icon: 'shopping-bag',
          url: 'orders',
          onlyRoles: [RolesEnum.Customer, RolesEnum.CustomerOwner, RolesEnum.AgencyOwner, RolesEnum.Agent, RolesEnum.StoreOwner, RolesEnum.StoreUser, RolesEnum.Administrator, RolesEnum.Designer]
        },
        {
          id: 'carts',
          title: 'MENU.CARTS',
          type: 'item',
          icon: 'shopping-cart',
          url: 'carts',
          onlyRoles: [RolesEnum.Customer, RolesEnum.CustomerOwner, RolesEnum.AgencyOwner, RolesEnum.Agent, RolesEnum.StoreOwner, RolesEnum.StoreUser, RolesEnum.Administrator, RolesEnum.Designer]
        },
        {
          id: 'returns',
          title: 'MENU.RETURNS',
          type: 'item',
          icon: 'corner-down-left',
          url: 'returns',
          onlyRoles: [RolesEnum.Administrator, RolesEnum.StoreOwner, RolesEnum.StoreUser],
          onlyTenantSetting: [TenantSettingType.ReturnsEnabled],
        },
        {
          id: 'customization-requests',
          title: 'MENU.CUSTOMIZATION_REQUESTS',
          type: 'item',
          icon: 'edit-2',
          url: 'customization-requests',
          onlyRoles: [RolesEnum.Customer, RolesEnum.CustomerOwner, RolesEnum.AgencyOwner, RolesEnum.Agent, RolesEnum.Designer, RolesEnum.StoreOwner, RolesEnum.StoreUser, RolesEnum.Administrator, RolesEnum.CustomerGuest]
        },
        {
          id: 'users',
          title: 'MENU.USERS',
          type: 'item',
          icon: 'users',
          url: 'users',
          onlyRoles: [RolesEnum.CustomerOwner]
        },
        {
          id: 'agents',
          title: 'MENU.AGENTS',
          type: 'item',
          icon: 'users',
          url: 'agents',
          onlyRoles: [RolesEnum.AgencyOwner]
        },
        {
          id: 'customers',
          title: 'MENU.CUSTOMERS',
          type: 'item',
          icon: 'book-open',
          url: 'customers',
          onlyRoles: [RolesEnum.AgencyOwner, RolesEnum.Agent]
        },
        {
          id: 'locations',
          title: 'MENU.LOCATIONS',
          type: 'item',
          icon: 'map-pin',
          url: 'locations',
          onlyRoles: [RolesEnum.CustomerOwner, RolesEnum.Customer]
        },
        {
          id: 'promotions',
          title: 'MENU.PROMOTIONS',
          type: 'collapsible',
          icon: 'dollar-sign',
          onlyRoles: [RolesEnum.Administrator, RolesEnum.StoreOwner, RolesEnum.StoreUser],
          children: [
            {
              id: 'automatic-discounts',
              title: 'MENU.AUTOMATIC_DISCOUNTS',
              type: 'item',
              icon: 'circle',
              url: 'automatic-discounts'
            },
            {
              id: 'vouchers',
              title: 'MENU.VOUCHERS',
              type: 'item',
              icon: 'circle',
              url: 'vouchers'
            },
            {
              id: 'commercial-agreements',
              title: 'MENU.COMMERCIAL_AGREEMENTS',
              type: 'item',
              icon: 'circle',
              url: 'commercial-agreements'
            }
          ]
        },
        {
          id: 'products',
          title: 'MENU.PRODUCTS.NAME',
          type: 'collapsible',
          icon: 'database',
          onlyRoles: [RolesEnum.Administrator, RolesEnum.StoreOwner, RolesEnum.StoreUser, RolesEnum.Designer],
          children: [
            {
              id: 'products-list',
              title: 'MENU.PRODUCTS.PRODUCTS_LIST',
              type: 'item',
              icon: 'circle',
              url: 'products-list'
            },
            {
              id: 'assortments',
              title: 'MENU.PRODUCTS.ASSORTMENTS',
              type: 'item',
              icon: 'circle',
              url: 'assortments',
              onlyRoles: [RolesEnum.Administrator, RolesEnum.StoreOwner, RolesEnum.StoreUser],
            },
            {
              id: 'import-products',
              title: 'MENU.PRODUCTS.IMPORT_PRODUCTS',
              type: 'item',
              icon: 'circle',
              url: 'import-products',
              onlyRoles: [RolesEnum.Administrator, RolesEnum.StoreOwner, RolesEnum.StoreUser]
            },
            {
              id: 'variant-bulk-editor',
              title: 'MENU.PRODUCTS.VARIANT_BULK_EDITOR',
              type: 'item',
              icon: 'circle',
              url: 'variant-bulk-editor',
              onlyRoles: [RolesEnum.Administrator, RolesEnum.StoreOwner, RolesEnum.StoreUser],
            },
            {
              id: 'bulk-editor',
              title: 'MENU.PRODUCTS.BULK_EDITOR',
              type: 'item',
              icon: 'circle',
              url: 'bulk-editor',
              onlyRoles: [RolesEnum.Administrator, RolesEnum.StoreOwner, RolesEnum.StoreUser],
              // badge: { title: 'New', classes: 'background-info' }
            },
            {
              id: 'inventory',
              title: 'MENU.PRODUCTS.INVENTORY_VISIBILITY',
              type: 'item',
              icon: 'circle',
              url: 'inventory'
            },
          ]
        },
        {
          id: 'settings',
          title: 'MENU.SETTINGS.NAME',
          type: 'collapsible',
          icon: 'settings',
          onlyRoles: [RolesEnum.Administrator, RolesEnum.StoreOwner, RolesEnum.StoreUser],
          children: [
            {
              id: 'store-setting',
              title: 'MENU.SETTINGS.STORE_SETTINGS',
              type: 'item',
              icon: 'circle',
              url: 'store-setting'
            },
            {
              id: 'seasons-reference',
              title: 'TABLE.SEASON_REFERENCE.NAME',
              type: 'item',
              icon: 'circle',
              url: 'seasons-reference'
            },
            {
              id: 'show-cases',
              title: 'TABLE.SHOWCASES.NAME',
              type: 'item',
              icon: 'circle',
              url: 'show-cases'
            },
            {
              id: 'pricelist',
              title: 'MENU.SETTINGS.PRICE_LIST',
              type: 'item',
              icon: 'circle',
              url: 'pricelist'
            },
            {
              id: 'tiers',
              title: 'MENU.SETTINGS.TIERS',
              type: 'item',
              icon: 'circle',
              url: 'tiers'
            },
            {
              id: 'sales-campaigns',
              title: 'MENU.SETTINGS.SALES_CAMPAIGNS',
              type: 'item',
              icon: 'circle',
              url: 'sales-campaigns'
            },
            {
              id: 'terms-of-sale',
              title: 'MENU.SETTINGS.TERMS_OF_SALE',
              type: 'item',
              icon: 'circle',
              url: 'terms-of-sale'
            },
          ]
        },
        // {
        //   id: 'tutorial',
        //   title: 'MENU.TUTORIAL.NAME',
        //   type: 'collapsible',
        //   icon: 'external-link',
        //   onlyRoles: [RolesEnum.Administrator, RolesEnum.StoreOwner, RolesEnum.StoreUser],
        //   children: [
        //     {
        //       id: 'tutorial-4shop-video',
        //       title: 'MENU.TUTORIAL.VIDEO',
        //       type: 'item',
        //       icon: 'circle',
        //       url: 'https://basicnetspa-my.sharepoint.com/:f:/g/personal/ammendola_basic_net/Eqj699kMCXZLu3_6Kx72P8MB7wkeEgjpW-u2tsJbn-FgTQ',
        //       externalUrl: true,
        //       openInNewTab: true
        //     },
        //     {
        //       id: 'tutorial-4shop-documentation',
        //       title: 'MENU.TUTORIAL.DOCUMENTATION',
        //       type: 'item',
        //       icon: 'circle',
        //       url: 'documentation-4shop',
        //       onlyRoles: [RolesEnum.Administrator, RolesEnum.StoreOwner, RolesEnum.StoreUser],
        //     }
        //   ]
        // },
        {
          id: 'downloads',
          title: 'MENU.DOWNLOADS.DOWNLOADS',
          type: 'collapsible',
          icon: 'download',
          children: [
            {
              id: 'basic-downloads',
              title: 'MENU.DOWNLOADS.DOWNLOADS',
              type: 'item',
              icon: 'circle',
              url: 'downloads'
            },
            {
              id: 'reports',
              title: 'MENU.DOWNLOADS.REPORTS',
              type: 'item',
              icon: 'circle',
              url: 'reports',
              onlyRoles: [RolesEnum.Administrator, RolesEnum.StoreOwner, RolesEnum.StoreUser],
            }
          ]
        },
        {
          id: 'utilities',
          title: 'MENU.UTILITIES.UTILITIES',
          type: 'collapsible',
          icon: 'tool',
          onlyRoles: [RolesEnum.Administrator, RolesEnum.StoreOwner, RolesEnum.StoreUser],
          children: [
            {
              id: 'basic-sync-handler',
              title: 'MENU.UTILITIES.UTILITIES',
              type: 'item',
              icon: 'circle',
              url: 'utilities'
            },
            {
              id: 'bulk-operations',
              title: 'MENU.UTILITIES.BULK_OPERATIONS',
              type: 'item',
              icon: 'circle',
              onlyTenantSetting: [TenantSettingType.EnabledOrdesBulkOperations],
              url: 'bulk-operations'
            }
          ]
        }
      ]
    },
    {
      id: 'crm',
      title: 'Crm',
      type: 'section',
      onlyRoles: [RolesEnum.Administrator, RolesEnum.StoreOwner, RolesEnum.StoreUser],
      children: [
        {
          id: 'agencies',
          title: 'MENU.AGENCIES',
          type: 'item',
          icon: 'briefcase',
          url: 'crm/agencies'
        },
        {
          id: 'customers',
          title: 'MENU.CUSTOMERS',
          type: 'item',
          icon: 'book-open',
          url: 'crm/customers'
        },
        {
          id: 'locations',
          title: 'MENU.LOCATIONS',
          type: 'item',
          icon: 'map-pin',
          url: 'crm/locations'
        },
        {
          id: 'users',
          title: 'MENU.USERS',
          type: 'item',
          icon: 'users',
          url: 'crm/users',
          onlyRoles: [RolesEnum.StoreOwner, RolesEnum.Administrator]
        },
        {
          id: 'general-fields',
          title: 'MENU.GENERAL_FIELDS',
          type: 'item',
          icon: 'edit-2',
          url: 'crm/manage-general-fields',
          onlyRoles: [RolesEnum.Administrator],
          onlyFESuperAdmin: true
        },
      ]
    }
  ]
});
